import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  duplicateTemplate,
  removeTemplate,
  removeVideoTemplate,
  updateTemplate,
} from "../../thunks/editor/templateThunks";
import { Dropdown } from "../common/dropdown";
import { downloadVideo } from "../../thunks/dashboardThunks";
import { Modal } from "../common/modal";

const TemplateDropdownMenu = ({
  className,
  template,
  isUserTemplate,
  handleClose,
  isFavorite,
  isVideoTemplate,
  isTemplatePopover,
  handleEditTitle = () => {},
  showTitleEdit = false,
}) => {
  const [confirmModal, setConfirmModal] = useState(false);
  const { isAdmin } = useSelector((state) => state.user);
  const { activeLayout } = useSelector((state) => state.templates);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const isTheme = useMemo(() => {
    return location.pathname.includes("/templates");
  }, []);

  const handleLike = () => {
    handleClose();
    return dispatch(
      updateTemplate(template.id, !isFavorite, isTemplatePopover)
    );
  };

  const handleDuplicate = () => {
    handleClose();
    return dispatch(
      duplicateTemplate(template.id, navigate, activeLayout, isTheme)
    );
  };

  const handleConfirmationModal = () => {
    console.log("handleCoonfirm modal", confirmModal);
    if (confirmModal) {
      setConfirmModal(false);
    } else {
      setConfirmModal(true);
      // handleClose();
    }
  };
  const handleDelete = () => {
    if (!confirmModal) {
      return;
    }
    if (isVideoTemplate) {
      return dispatch(removeVideoTemplate(template.id));
    }
    return dispatch(
      removeTemplate(template.id, isUserTemplate, isTemplatePopover)
    );
  };
  const handleDownalod = () => {
    console.log(template);
    handleClose();
    dispatch(downloadVideo(template.id));
  };

  const handleEdit = () => {
    handleEditTitle();
    handleClose();
  };
  const slideMenu = useMemo(
    () => [
      {
        title: "Remove",
        onClick: handleConfirmationModal,
        icon: "/tool/dashboard/static/images/icons/tools/delete.svg",
        isHidden: !isAdmin && !isUserTemplate && !isVideoTemplate,
      },
      {
        title: isFavorite ? "Remove like" : "Like",
        onClick: handleLike,
        icon: "/tool/dashboard/static/images/icons/tools/like.svg",
        isHidden: !isUserTemplate || isVideoTemplate,
      },
      {
        title: "Duplicate",
        onClick: handleDuplicate,
        icon: "/tool/dashboard/static/images/icons/tools/duplicate.svg",
        isHidden: isVideoTemplate || !isUserTemplate,
      },
      {
        title: "Download",
        onClick: handleDownalod,
        icon: "/tool/dashboard/static/images/Download-icon.png",
        isHidden: !isVideoTemplate,
      },
      {
        title: "Edit Title",
        onClick: handleEdit,
        icon: "/tool/dashboard/static/images/icons/tools/edit.svg",
        isHidden: !showTitleEdit || isTheme,
      },
    ],
    [confirmModal]
  );

  return (
    <>
      <Modal
        hideClose
        onClose={() => handleClose(true)}
        open={confirmModal}
        center
        confirmText="Delete"
        onSubmit={handleDelete}
        cancelText="Cancel"
        classes={{
          wrapper: "!z-50",
          body: "!z-50",
          backdrop: "!z-50",
        }}
      >
        Are you sure want to delete?
      </Modal>
      {!!slideMenu.length && (
        <Dropdown menu={slideMenu} className={className + " !z-20"} />
      )}
    </>
  );
};

export default TemplateDropdownMenu;
